import { Lumisial } from '../lib/supabase';

/**
 * Persistencia del lumisial seleccionado. Lo guardado lleva el dueño adentro: sin eso,
 * al abrir la app de cero (el caso normal en celular) se restauraba el lumisial de quien
 * usó el dispositivo antes, y el usuario terminaba operando sobre un lumisial ajeno —
 * con la base rechazándole toda escritura por permisos.
 */

// La clave va versionada: el formato v1 guardaba el Lumisial pelado, sin dueño. Con
// clave nueva, ese formato no puede volver a leerse ni por accidente.
const STORAGE_KEY = 'selectedLumisial:v2';
const STORAGE_KEY_V1 = 'selectedLumisial';

interface StoredSelection {
  readonly userId: string;
  readonly lumisial: Lumisial;
}

export const leerLumisialPersistido = (userId: string | null): Lumisial | null => {
  if (!userId) return null;
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (!stored) return null;
    const parsed = JSON.parse(stored) as Partial<StoredSelection>;
    if (parsed.userId !== userId || !parsed.lumisial) return null;
    return parsed.lumisial;
  } catch {
    return null;
  }
};

export const guardarLumisialPersistido = (userId: string, lumisial: Lumisial): void => {
  const payload: StoredSelection = { userId, lumisial };
  localStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
  localStorage.removeItem(STORAGE_KEY_V1);
};

export const olvidarLumisialPersistido = (): void => {
  localStorage.removeItem(STORAGE_KEY);
  localStorage.removeItem(STORAGE_KEY_V1);
};
